import { Link } from 'react-router-dom';
import { stats } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20artistic%20illustration%20of%20glowing%20connected%20nodes%20and%20flowing%20organic%20shapes%2C%20deep%20warm%20maroon%20and%20coral%20and%20amber%20palette%20with%20subtle%20green%20accents%2C%20soft%20gradient%20light%2C%20rich%20dark%20background%20with%20depth%2C%20editorial%20magazine%20hero%20art%2C%20high%20detail&width=1600&height=1000&seq=hero-gossip-main&orientation=landscape"
        alt="911吃瓜 人物关系网络的艺术化背景图"
        title="911吃瓜 - 人物关系图与矛盾链条"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/45" aria-hidden="true" />

      <div className="relative z-10 w-full px-4 md:px-8 py-24">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur animate-rise">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-radar-line" />
            </span>
            娱乐关系图谱 · 每日更新
          </span>

          <h1 className="mt-6 font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-[1.15] animate-rise">
            911吃瓜：吃透每一个瓜的来龙去脉
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg leading-7 md:leading-8 text-background-100/90 animate-rise">
            我们把零散的信息整理成<span className="text-accent-400 font-semibold">人物关系图</span>、
            <span className="text-accent-400 font-semibold">矛盾链条</span>与
            <span className="text-accent-400 font-semibold">当事人回应</span>合集，让圈内关系一目了然，看透人物背后的关系网。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-rise">
            <Link
              to="/cases"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line" />
              查看今日主瓜
            </Link>
            <Link
              to="/charts"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap backdrop-blur"
            >
              <i className="ri-git-branch-line" />
              浏览人物关系图
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-6 max-w-3xl">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs md:text-sm text-background-100/70">{item.label}</dt>
                <dd className="mt-1 font-heading font-black text-2xl md:text-3xl text-background-50">
                  {item.value}
                  <span className="text-sm font-medium text-background-100/70 ml-1">{item.suffix}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}